import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

import Canvas from './view/2D';
import ToolBar from './view/controlPanel/ToolBar';
import Modals from "./components/Modals/Modals";
import Init from './components/Init/Init';
import { ToastContainer } from 'react-toastify';

const InitialScreen = () => {
  const { t } = useTranslation();
  return <div className='acp-initial-screen-canvas'>
    <h2>{t('Please set the background.')}</h2>
  </div>
}

function App() {
  const coloursOnCanvas = useSelector((state) => state.Feature.coloursOnCanvas);
  return (
    <>
      <div className="acp-row acp-App">
        <div className="acp-col-12 acp-col-md-8 acp-canvas-wrapper">
          <Canvas />
          {coloursOnCanvas.length === 0 && <InitialScreen />}
        </div>
        <div className="acp-col-12 acp-col-md-4 acp-h-100">
          <ToolBar />
        </div>
        <Modals />
        <Init />
        <ToastContainer />
      </div>
    </>
  );
}

export default App;
